exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item-inside[data-v-4d49eb44]{width:85%}", ""]);

// exports
